var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 404,
    viewBox: "0 0 404 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.092 393.266C307.568 393.266 393.073 307.761 393.073 202.284C393.073 96.8081 307.568 11.3027 202.092 11.3027C96.6157 11.3027 11.1104 96.8081 11.1104 202.284C11.1104 307.761 96.6157 393.266 202.092 393.266Z",
    fill: "white",
    stroke: "#474799",
    strokeWidth: 20.9223
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.106 376.115L112.557 289.667L149.217 252.704L199.106 376.115Z",
    fill: "url(#paint0_linear_2375_49)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.956 85.4615C139.699 88.7184 97.9139 118.587 106.801 169.689C110.883 193.162 136.795 218.467 158.155 244.17C188.534 280.725 194.289 290.453 199.576 303.769C212.536 336.408 201.127 369.854 199.41 376.62C199.41 376.62 226.773 355.316 231.98 326.68C236.323 302.795 235.315 296.627 233.509 285.793C229.167 259.737 210.462 237.871 188.554 213.771C166.84 189.887 164.886 188.416 148.914 167.265C139.573 154.894 134.175 142.825 133.867 127.474C133.412 104.853 145.832 82.5856 142.956 85.4615H142.956Z",
    fill: "url(#paint1_linear_2375_49)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.012 63.5723C164.012 63.5723 165.307 65.29 167.724 66.1475C170.918 67.2803 175.819 67.5791 179.767 63.7236C183.331 60.2432 183.119 55.1982 181.964 52.0596C181.032 49.5283 179.388 48.1963 179.388 48.1963L181.584 45.9238C181.584 45.9238 182.456 47.2412 184.387 48.1201C187.663 49.6113 193.294 50.3643 197.87 45.0898C201.196 41.2549 200.443 36.6523 199.081 33.7295C198.211 31.8613 197.047 30.4756 197.037 30.3965C197.011 30.1943 199.536 27.7451 199.536 27.7451L286.984 115.774L274.749 127.575C274.749 127.575 263.944 114.042 252.127 113.438C245.294 113.086 241.342 113.088 234.272 114.704C227.923 116.156 224.538 117.883 216.874 113.803C207.239 108.674 207.438 98.2715 207.69 92.7842C207.892 88.3916 205.822 85.916 202.843 85.8154C200.217 85.7266 197.598 86.71 197.037 90.915C195.888 99.5244 196.949 105.422 203.413 115.725C209.629 125.628 233.83 149.501 241.876 158.782C250.511 168.741 257.632 174.233 271.266 193.321C280.553 206.324 293.079 224.83 293.079 247.553C293.079 264.723 288.029 275.175 281.516 288.203C275.001 301.23 254.703 321.58 255.056 320.772C255.41 319.964 262.631 297.594 261.318 270.276C259.684 236.288 229.809 209.682 213.246 189.888C199.844 173.871 187.997 161.738 174.465 143.027C151.236 110.912 164.012 63.5723 164.012 63.5723L164.012 63.5723Z",
    fill: "url(#paint2_linear_2375_49)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2375_49",
    x1: 112.557,
    y1: 314.41,
    x2: 199.106,
    y2: 314.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0965195,
    stopColor: "#73BFB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263228,
    stopColor: "#4F9994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746362,
    stopColor: "#40418F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2375_49",
    x1: 105.563,
    y1: 230.915,
    x2: 235.055,
    y2: 230.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0724702,
    stopColor: "#79C2BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26659,
    stopColor: "#46998F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847698,
    stopColor: "#484997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2375_49",
    x1: 311.419,
    y1: 288.261,
    x2: 170.642,
    y2: 44.4271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79C2BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264171,
    stopColor: "#46998F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380193,
    stopColor: "#468C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592518,
    stopColor: "#476A93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776839,
    stopColor: "#484997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353681"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdl);
export default __webpack_public_path__ + "static/media/sdl.8d8e380b0184b8d2a492cdfae916cbe0.svg";
export { ForwardRef as ReactComponent };